import { gql } from "@apollo/client";

export const SYNCHRONIZATION_STATUS_CHANGED = gql`
  subscription synchronizationStatusChanged($partnerId: Int!) {
    synchronizationStatusChanged(partnerId: $partnerId) {
      partnerId
      synchronizationInProgress
    }
  }
`;
